<template>
  <div>
    <!-- 通知公告 -->
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      @searchSubmit="searchSubmit"
      @handleSelectionChange="handleSelectionChange"
      @delBtn="delBtn"
      @refresh-change="getlist"
      @addSubmit="addSubmit"
      @etidSubmit="etidSubmit"
      @refreshBtn="refreshBtn"
    ></zx-table>
    <ele-form-dialog
      v-model="formData"
      :formDesc="formDesc"
      :request-fn="handleSubmit"
      :rules="rules"
      labelPosition="left"
      :form-attrs="{ size: 'small' }"
      :dialogAttrs="{
        center: false,
        'destroy-on-close': true,
        'custom-class': 'formD'
      }"
      v-dialogdrag
      :visible.sync="dialogFormVisible"
      @request-success="handleSuccess"
      :title="formTitle"
    ></ele-form-dialog>
  </div>
</template>

<script>
import * as notice from "@/api/notice/notice.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      formTitle: "111222",
      rules: {},
      formData: {},
      formDesc: {},
      dialogFormVisible: false,
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [1, 3, 10, 20, 30, 40, 50, 100],
        // sizes, prev, pager, next, jumper, ->, total, slot
        // "layout":"prev, pager, next",
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "通知",
        // 表格底部按钮
        btnBottom: false,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        // 多选 默认:false;
        // selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: false,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: true,
        // 编辑 默认:true;
        editBtn: true,
        // 删除  默认:true;
        delBtn: true,
        // 折叠筐 默认:false;
        expand: false,
        column: [
          {
            prop: "notice_title",
            label: "公告标题",
            type: "input",
            nowrap: true,
            hide: true
          },
          {
            prop: "notice_content",
            label: "公告标题",
            // type: "quill-editor",
            type: "quill-editor", // 只需要在这里指定为 quill-editor 即可
            // 属性由两部分组成
            // 1.上传图片相关属性
            // 2.编辑器相关属性, 参考: https://github.com/davidroyer/vue2-editor 和 https://quilljs.com/
            attrs: {
              // 上传相关
              action: "https://xxx.com/upload/images", // 上传地址
              data: { token: "xxx" },
              // 对响应结果进一步处理
              responseFn(response, file) {
                // return 'https://xxx.com/upload/images' + response // 这里返回上传后的url即可
              },
              // 编辑器相关属性
              placeholder: "请输入..."
            },
            hide: false
          },
          {
            prop: "notice_type",
            label: "公告类型",
            type: "radio",
            show: "tag",
            width: 100,
            default: 0,
            options: [
              {
                text: "公告",
                value: 1
              },
              {
                text: "通知",
                value: 2
              }
            ],
            tagtype: [
              {
                text: "公告",
                value: 1
              },
              {
                text: "通知",
                value: 2
              }
            ],
            hide: true
          },
          {
            prop: "status",
            label: "状态",
            type: "radio",
            width: 100,
            show: "tag",
            default: 0,
            options: [
              {
                text: "启用",
                value: 0
              },
              {
                text: "禁用",
                value: 1
              }
            ],
            tagtype: [
              {
                text: "启用",
                type: "success",
                value: 0
              },
              {
                text: "禁用",
                type: "danger",
                value: 1
              }
            ],
            hide: true
          },
          {
            prop: "create_by",
            label: "创建人",
            type: "input",
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: false,
            // 该字段是否可以修改默认true
            editDisplay: false,
            hide: true
          },
          {
            prop: "create_time",
            label: "创建时间",
            type: "input",
            hide: true,
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: false,
            // 该字段是否可以修改默认true
            editDisplay: false
          }
        ]
        // btnNavLeft:[
        //   {
        //     text:'添加'
        //   }
        // ]
      },
      tableData: []
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    handleSubmit(data) {},
    // 提交成功
    handleSuccess() {
      this.dialogFormVisible = false;
    },
    // 添加提交
    addSubmit(form) {
      form["menu_ids"] = [];
      notice.addNotice.r(form).then(res => {
        this.$message.success("公告《" + res.notice_title + "》创建成功");
        this.getlist();
      });
    },
    // 编辑
    etidSubmit(form) {
      notice.editNotice.r(form).then(res => {
        this.$message.success("修改成功");
        this.getlist();
      });
    },
    // 删除
    delBtn(form) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          notice.deleteNotice.r({ notice_id: form.notice_id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getlist();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //   多选
    handleSelectionChange(e) {},
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    // 分页器
    refreshChange(e) {
      let that = this;
      setTimeout(() => {
        this.getlist();
      }, 1000);
    },
    getlist(e) {
      let param;
      let that = this;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      notice.getNoticeList.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    }
  }
};
</script>
